<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{ props.row.MagyPagoQty }}</a>
  </div>
</template>

<script>
import store from "../../../../store/index";
export default {
  name: "mpagoLink",
  show(ops) {
    store.dispatch("getAllTerminalAndServicesAsync", {
      Rnc: ops.row.Rnc,
      type: 2
    });
  }
};
</script>
